// Home Vuex

import state from './homeStates.js'
import * as getters from './homeGetters.js'
import * as mutations from './homeMutations.js'
import * as actions from './homeActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
